import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useHistory, useLocation} from 'react-router-dom';
import useApi from '../../hooks/useApi';
import {logPageLoadEvents} from '@ibibo/analytics';
import {getQueryString} from '../../utils/utils';
import OnboardingNew from '../../stories/components/OnboardingNew/OnboardingNew';
import OtpVerified from '../../stories/components/OnboardingNew/CommonComponents/OtpVerified/OtpVerified';
import EyeIconComponent from '../../stories/components/OnboardingNew/PopUp/CreatePassword/EyeIcon';
import AppButon from '../../stories/components/OnboardingNew/GccComponents/AppButon/AppButon';
import * as S from '../../stories/components/OnboardingNew/GccComponents/TextInput/TextInput.styles';
import {HOME_PAGE_URL_NEW} from '../../constants';
import {updateUrlWithNewCrid} from '../../../../myaccount/src/utils/redirectWithCrId';
const CreateSubUserAccount = () => {
  const host = `${__ENV_CONFIG__.MYPARTNER}`;
  const history = useHistory();
  const passwordRegex = new RegExp(
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
  );
  const subUserToken = getQueryString('subuserToken', window.location.href);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [screenName, setScreenName] = useState('SUBUSER_CREATE_ACCOUNT');

  const {
    register,
    handleSubmit,
    getValues,
    formState: {isDirty, errors},
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });
  const {
    isLoading: isLoadingData,
    data: submitDataResponse,
    error: errorResponseData,
    fetchData: submitData,
    postData: postData,
  } = useApi();

  useEffect(() => {
    //updateUrlWithNewCrid(); FIX THIS LATER
  }, []);

  useEffect(() => {
    logPageLoadEvents('platform:subUserOnboarding|mypartner', {
      eVar15: 'platform:subUserOnboarding|mypartner',
      prop54: 'myp_sub_CompleteProfileSection',
    });
  }, []);

  useEffect(() => {
    if (
      submitDataResponse?.screen === 'SUBUSER_ACCOUNT_VERIFIED' ||
      submitDataResponse?.screen === 'SUBUSER_OTP_VERIFIED'
    ) {
      setScreenName('SUBUSER_ACCOUNT_VERIFIED');
      logPageLoadEvents('platform:subUserOnboarding|mypartner', {
        eVar15: 'platform:subUserOnboarding|mypartner',
        prop54: 'myp_sub_AccountCreated',
      });
    }
  }, [submitDataResponse]);

  const onSubmit = data => {
    const url = `${host}/agents/subuser-profile-creation/`;
    postData(url, {...data, token: subUserToken});
  };

  const handleCloseModal = () => {
    history.push(`${HOME_PAGE_URL_NEW}`);
  };

  return (
    <OnboardingNew step={1} showBackButton={false}>
      {screenName === 'SUBUSER_CREATE_ACCOUNT' ? (
        <>
          <S.HeadingText>Complete Your Profile</S.HeadingText>
          <br />
          <S.SubHeadingText>Tell us little bit about yourself</S.SubHeadingText>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Name input */}
            <S.InputContainer setMargin={true}>
              <label>{'First Name'}</label>
              <S.InputWrapper>
                <input
                  type="text"
                  {...register('first_name', {required: 'First Name is required'})}
                />
              </S.InputWrapper>
            </S.InputContainer>
            {errors.first_name && (
              <S.FieldErrorMessage>{errors?.first_name?.message}</S.FieldErrorMessage>
            )}
            <S.InputContainer setMargin={true}>
              <label>{'Last Name'}</label>
              <S.InputWrapper>
                <input
                  type="text"
                  {...register('last_name', {required: 'Last Name is required'})}
                />
              </S.InputWrapper>
            </S.InputContainer>
            {errors.last_name && (
              <S.FieldErrorMessage>{errors?.last_name?.message}</S.FieldErrorMessage>
            )}
            <S.PasswordInputContainer setMargin={true}>
              <label>{'Password'}</label>
              <S.PasswordInputWrapper>
                <input
                  type={!showPassword ? 'password' : 'text'}
                  name="password"
                  {...register('password', {
                    required: 'Password is required',
                    validate: val => {
                      if (!passwordRegex.test(val)) {
                        return 'Ensure the password is at least 8 characters long and includes at least one uppercase letter, one lowercase letter, one digit, and one special character from the set #?!@$%^&*-.';
                      }
                    },
                  })}
                />
                <EyeIconComponent
                  showPassword={showPassword}
                  setShowPassword={() => setShowPassword(!showPassword)}
                />
              </S.PasswordInputWrapper>
            </S.PasswordInputContainer>
            {errors.password && (
              <S.FieldErrorMessage>{errors?.password?.message}</S.FieldErrorMessage>
            )}
            <S.PasswordInputContainer setMargin={true}>
              <label>{'Confirm Password'}</label>
              <S.PasswordInputWrapper>
                <input
                  type={!showConfirmPassword ? 'password' : 'text'}
                  name="confirm_password"
                  {...register('confirm_password', {
                    required: 'Password is required',
                    validate: (val: string, allValues) => {
                      if (allValues.password != val) {
                        return 'Your passwords do no match';
                      }
                    },
                  })}
                />
                <EyeIconComponent
                  showPassword={showConfirmPassword}
                  setShowPassword={() => setShowConfirmPassword(!showConfirmPassword)}
                />
              </S.PasswordInputWrapper>
              {errors.confirm_password && (
                <S.FieldErrorMessage>{errors?.confirm_password?.message}</S.FieldErrorMessage>
              )}
            </S.PasswordInputContainer>
            <S.TncText>
              By clicking Create Account, you acknowledge you have read and agreed to our MakeMy
              Trip's <span className="latoBlack">Terms of Use</span> and{' '}
              <span className="latoBlack">Privacy Policy</span>
            </S.TncText>
            <AppButon type="submit" buttonText={'Create Account'} />
          </form>
          {errorResponseData && <S.ErrorMsg>{errorResponseData?.message}</S.ErrorMsg>}
        </>
      ) : screenName == 'SUBUSER_ACCOUNT_VERIFIED' ? (
        <OtpVerified
          heading={submitDataResponse?.heading}
          isVerificationSuccessFull={true}
          message={submitDataResponse?.message}
          headingIcon={true}
          height={300}
          responseRedirectUrl={submitDataResponse?.responseRedirectUrl}
          subHeading={submitDataResponse?.subHeading}
          closeModal={true}
          handleCloseModal={handleCloseModal}
          isClosable={true}
        />
      ) : (
        <></>
      )}
    </OnboardingNew>
  );
};

export default CreateSubUserAccount;
